import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';


import { PrimeDialogComponent } from '../prime-dialog/prime-dialog.component';
import { PrimeButtonComponent } from '../prime-button/prime-button.component';
import { iconsSRC } from '@core/utils';

@Component({
  selector: 'error-dialog',
  standalone: true,
  imports: [
    PrimeDialogComponent,
    PrimeButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss'
})
export class ErrorDialogComponent {
  onClose = output<void>();

  icon = input<string>(`${iconsSRC}/alert.png`);
  title = input.required<string>();
  visible = input(false);

  breakpoints = {
    '1199px': '75vw',
    '575px': '90vw',
  };

  styles = {
    'max-width': '40rem',
    // 'min-width': '30rem',
    'heigh': '90vh',
    'min-height': '25rem'
  }


  handleClose() {
    this.onClose.emit();
  }
}
